import { useEffect, useState } from "react";
import { loadPurchaseOrderList } from "../services/purchaseIndentService";

const usePurchaseOrderList = (mode) => {
    const [dataLoad, setDataLoad] = useState(false);
    const [orderData, setOrderData] = useState([]);

    const loadData = async () => {
        try {
            const payload = {
                p_companyid: 1,                
            };

            const data = await loadPurchaseOrderList(payload);
            setOrderData(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error("Error loading received list:", error);
            setOrderData([]);
        } finally {
            setDataLoad(true);
        }
    };

    useEffect(() => {
        if (!dataLoad) {
            loadData();
        }
    }, [dataLoad, mode]); // Depend on mode in case it changes

    const refreshOrderListSummary = () => {
        setDataLoad(false); // Will re-trigger useEffect
    };

    return {
        orderData,
        setOrderData,
        refreshOrderListSummary,
    };
};

export default usePurchaseOrderList;
